const Utility = {
  getChannelTitle: (content, channelId) => {
    if (!content || !content.channels) return "Channel Not Found";
    const channel = content.channels.find((ch) => ch.channelId === channelId);
    return channel && channel.title ? channel.title : "Channel Not Found";
  },
  getChannelUrl: (content, channelId) => {
    if (!content || !content.channels) return "/";
    const channel = content.channels.find((ch) => ch.channelId === channelId);
    return channel && channel.url ? channel.url : "/";
  },
  getChannelHeaderLogo: (content, channelId) => {
    if (!content || !content.channels) return "";
    const channel = content.channels.find((ch) => ch.channelId === channelId);
    return channel && channel.headerLogo && channel.headerLogo.imageUrl
      ? channel.headerLogo.imageUrl
      : "";
  },
  getChannelFooterLogo: (content, channelId) => {
    if (!content || !content.channels) return "";
    const channel = content.channels.find((ch) => ch.channelId === channelId);
    return channel && channel.footerLogo && channel.footerLogo.imageUrl
      ? channel.footerLogo.imageUrl
      : "";
  },
  getChannelSocials: (content, channelId) => {
    if (!content || !content.channels) return [];
    const channel = content.channels.find((ch) => ch.channelId === channelId);
    return channel && channel.socials ? channel.socials : [];
  },
  getChannelFooterLinks: (content, channelId) => {
    if (!content || !content.channels) return [];
    const channel = content.channels.find((ch) => ch.channelId === channelId);
    return channel && channel.footerLinks ? channel.footerLinks : [];
  },
  getChannelMenu: (content, channelId) => {
    if (!content || !content.channels) return [];
    const channel = content.channels.find((ch) => ch.channelId === channelId);
    return channel && channel.mainMenu ? channel.mainMenu : [];
  },
  getChannel: (content, channelId) => {
    if (!content || !content.channels) return [];
    const channel = content.channels.find((ch) => ch.channelId === channelId);
    return channel ? channel : null;
  },
  getSlider: (content) => {
    if (!content || !content.sliderItems) return [];
    if (!content || !content.channels) return [];
    return content.sliderItems.map((item) => {
      const channel = content.channels.find(
        (ch) => ch.channelId === item.channelId
      );
      return {
        title: channel && channel.title ? channel.title : "-",
        url: channel && channel.url ? channel.url : "/",
        imageUrl: item.imageUrl,
        channelId: item.channelId,
      };
    });
  },
};
export default Utility;
